import {Component, Prop} from 'vue-property-decorator';

import _ from 'lodash'
import ColumnsService from '@/services/columns';
import Columns from './columns'
import query from '@/components/query/query-constructor';

@Component
export default class Resizer extends Columns {
  dragged: object = null;
  startWidth: number = 0;
  tableWidth: object = {};

  @Prop()
  columnsWidth: object;

  mounted() {
    if (this.treeLevel === 0) {
      this.bus.on('reset-table-width', this.resetTableWidth);
    }

    this.tableWidth = this.defaultWidth
  }

  beforeDestroy() {
    if (this.treeLevel === 0) {
      this.bus.off('reset-table-width');
    }
  }

  get defaultWidth() {
    const savedColumns = this.$store.getters.savedColumnsInCurentPreset
    const levels = query.decode(this.$route.params.report)?.levels || []  
  
    const groupingColumnsWidth = levels.reduce((acc,level)=>{
      if(level!=='none'){
        const mainColumnOfType = this.$store.state.reportColumns.dimensions[level].mainColumn
        acc[mainColumnOfType] = savedColumns[level]?.width[mainColumnOfType]
      }
      return acc;
    },{})
    
    return {...groupingColumnsWidth,...savedColumns[ColumnsService.type]?.width}
  }

  get dragData() {
    return this.dragged
  }

  set dragData(value) {
    this.dragged = value
  }

  get tableColumnsWidth() {
    return {
      ...this.tableWidth,
    }
  }

  storeType(name) {
    switch(name) {
      case 'app.conversions':
        return 'conversions';
      case 'app.postbacks':
        return 'postbacks';
      case 'app.errors':
        return 'errors';
      case 'app.live-visits':
        return 'live-visits';
      case 'app.live-clicks':
        return 'live-clicks';
      default:
        return name;
    }
  }

  getDefaultColumnWidth(column) {
    const { mainColumn } = this.tableFullDimensions[ColumnsService.type];

    return mainColumn === column ? 300 : 100
  }

  getColumnWidth(column) {
    if (this.treeLevel && this.treeLevelColumns[this.treeLevel - 1]?.value === column) {
      return this.getColumnWidth(this.rootGrouping)
    }

    if (this.columnsWidth) {
      return this.columnsWidth[column] || this.getDefaultColumnWidth(column)
    }

    return this.tableColumnsWidth[column] || this.getDefaultColumnWidth(column)
  }

  resetTableWidth() {
    const savedColumns = this.$store.getters.savedColumnsInCurentPreset

    this.tableWidth = savedColumns[ColumnsService.type]?.width
  }

  set tableColumnsWidth(data) {
    const { column: { value }, width } = data as any

    if (this.tableWidth[value] !== width && width) {
      this.$set(this.tableWidth, value, width)
    }
  }

  onDragStart(event, column) {
    this.dragData = {
      positionX: this.getEvent(event)?.clientX,
      column,
    }

    this.startWidth = this.getColumnWidth(column.value)
  }

  getMinColumnWidth({ columnName, type = ColumnsService.type }) {
    const { dimensions } = this.$store.state.reportColumns;

    return dimensions[type]?.mainColumn === columnName ? 50 : 20
  }

  onDragEnd(event) {
    if (!this.dragData) return

    const savedColumns = this.$store.getters.savedColumnsInCurentPreset
    const { column: { value: columnName }, positionX } = this.dragData as any

    const diff = Number(this.getEvent(event)?.clientX) - Number(positionX);

    const width = Math.max(this.startWidth + diff, this.getMinColumnWidth({ columnName }))

    const { user: { independentColumnSettingsEnabled } } = this.$store.state;

    let contexts = [ColumnsService.type]

    if(!independentColumnSettingsEnabled) {
      contexts = _.uniq([
        ...contexts,
        ...Object.keys(this.tableFullDimensions).filter(key => _.get(savedColumns, [key, 'columns'], []).includes(columnName))
      ])
    }

    this.$store.dispatch('patchWidth', { contexts, columnName, width: Math.floor(width) })

    this.columnSettingsApi.updateColumnWidth({
      columnName,
      columnWidth: Math.floor(width),
      contexts,
      id:this.$store.state.report.activePreset,
    });

    this.dragData = null
  }

  getEvent(event) {
    switch (event.type) {
      case 'touchmove':
      case 'touchstart':
      case 'touchend':
        return _.get(event, ['changedTouches', 0])
      default:
        return event
    }
  }

  resize(event) {
    if (!this.dragData) return

    const { positionX, column } = this.dragData as any
    const diff = Number(this.getEvent(event)?.clientX) - Number(positionX);

    const width = Math.max(this.startWidth + diff, this.getMinColumnWidth({ columnName: column.value }))

    this.tableColumnsWidth = { width, column }
  }

  resizeColumn = _.throttle(this.resize, 50)

  get tableResizers() {
    let width = (this as any).firstColumnsOffset
    return this.tableHeaders.map((columnName: string) => ({
      value: columnName,
      width: width += this.getColumnWidth(columnName),
    }))
  }
}
